import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";

const title = "JTB Floors — Professional Flooring in Barrington, IL";
const description =
  "Professional hardwood, ceramic, laminate, tile & marble flooring. 35 years experience. Serving Barrington, IL and 35 miles out. (773) 934-2004";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/` },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/` }],
  }),
  component: Index,
});
